import { atom } from "recoil";

export const userState = atom({
  key: "userState",
  default: null,
});

export const agreePrivacyPolicyState = atom({
  key: "agreePrivacyPolicyState",
  default: false,
});

export const agreeMarkekingState = atom({
  key: "agreeMarkekingState",
  default: false,
});

export const indicatorState = atom({
  key: "indicatorState",
  default: "홈",
});

export const employeeListState = atom({
  key: "employeeListState",
  default: [],
});

export const cardListState = atom({
  key: "cardListState",
  default: [],
});

export const leftEmployeeCheckListState = atom({
  key: "leftEmployeeCheckListState",
  default: [],
});

export const rightEmployeeCheckListState = atom({
  key: "rightEmployeeCheckListState",
  default: [],
});

export const payFailListState = atom({
  key: "payFailListState",
  default: [],
});

export const groupListState = atom({
  key: "groupListState",
  default: [],
});

export const adminListState = atom({
  key: "adminListState",
  default: [],
});

export const callNumberState = atom({
  key: "callNumberState",
  default: "",
});

export const historyStartDateState = atom({
  key: "historyStartDateState",
  default: "",
});

export const historyEndDateState = atom({
  key: "historyEndDateState",
  default: "",
});

export const historyGroupState = atom({
  key: "historyGroupState",
  default: "",
});

export const historyEmailState = atom({
  key: "historyEmailState",
  default: "",
});

export const historyPaymentState = atom({
  key: "historyPaymentState",
  default: "",
});

export const companyFileNameState = atom({
  key: "companyFileNameState",
  default: "",
});
